import { Component } from 'vue-property-decorator'
import { SaveTrainingPlan } from '@src/routes/content/components/training-plan-builder/save-plan'

@Component
export class SaveMemberTrainingPlan extends SaveTrainingPlan {

  createTrainingPlan (done) {
    // overwritten this because there is no need to create a club owned plan
    const trainingDays = this.formatTrainingDays(false)
    done(null, trainingDays)
  }
}
